import { atom } from "jotai";

export const feeFiltersAtom = atom<any>({
  dataType: "Sum ||",
  dateType: "Last 7 Days",
});
